import { ComponentType, FrameConfiguration, TempleInfoMap } from './FrameConfiguration.js'

const combinationTypes: Record<string, string[]> = {
	'COMB-TA': ['ACETATE', 'T-PLATE'],
	'COMB-TN': ['NOW', 'T-WIRE'],
	'COMB-AG': ['ACETATE', 'T4046'],
	'COMB-HG': ['AU750', 'HORN'],
	'COMB-HP': ['PT950', 'HORN'],
	'AU750': ['AU750', 'AU750']
}

export function ConfigurationInterpreter(config: FrameConfiguration, templeData: TempleInfoMap): FrameConfiguration {
	config = JSON.parse(JSON.stringify(config))

	let baseProductline = config.productline

	if (config.productline.startsWith('RIM')) {
		baseProductline = 'RIM'
		if (['ATTILA', 'DIRK', 'FLEMMING', 'JAIME', 'JOHN', 'MATHIAS', 'OVAL', 'RUSSEL', 'RYAN'].includes(config.components.MODEL?.design)) {
			config.productline = 'RIMTEEN' // TODO: Get From Data
		}
	} else if (config.productline == '1600') {
		baseProductline = '1000'
	} else if (config.productline == '1000TEEN' || config.productline as any == '1000 TEEN') {
		config.productline = '1000TEEN'
		baseProductline = '1000'
	} else if (config.components.MODEL?.design?.startsWith('81') && config.components.BRIDGE?.design) {
		config.isRimless = true // Override Customiser behaviour
		baseProductline = 'SPI'
	} else if (config.components.MODEL?.design?.startsWith('82')) {
		baseProductline = 'RIM'
	} else if (config.components.MODEL?.design?.startsWith('83')) {
		baseProductline = '6500'
	} else if (config.components.MODEL?.design?.startsWith('85')) {
		baseProductline = '1000'
	}

	if (config.productline == 'RIM40TH' && isNaN(parseInt(config.components.MODEL?.design))) {
		config.components.MODEL.design = config.components.MODEL.design + '40'
	}

	for (const key of Object.keys(config.components)) {
		const comp = config.components[key as ComponentType]

		// Split Combination Colors to separate elements        //TODO: MOVE TO TEMPLE
		const colors = splitColorCodes(comp.color, true)
		if (colors?.length > 1) {
			const combinationType = comp.color.split('/')[0]
			if (combinationType == 'COMB-HG' || combinationType == 'COMB-HP') {
				comp.color = colors[0]
				config.components.TEMPLE_HORN = { color: colors[1] }
			} else if (combinationType == 'COMB-TA') {
				comp.color = colors[1]
				config.components.TEMPLE_ACETATE = { color: colors[0] }
			} else if (combinationType == 'COMB-TN') {
				comp.color = colors[0]
				config.components.CROSSBAR = { color: colors[1] }
			} else if (combinationType == 'COMB-AG') {
				comp.color = colors[0]
				config.components.GROOVE = { color: colors[1] }
			} else if (combinationType == 'AU750') {
				comp.color = colors[0]
				config.components.TEMPLE_DETAIL = { color: colors[1].replaceAll(/\(|\)/gi, '') } // (YG) TO YG
			} else {
				console.warn(`Unknown combination type: ${combinationType}`)
			}
		}

		// Delete Fixed sizes
		if (comp.size == 'FIXED') delete comp.size

		// Precious Move Finish from Temple Design to Color (Material) //TODO: Refactor
		if (comp.design?.includes(';')) {
			const [design, finish] = comp.design.split(';')
			comp.design = design
			if (comp.color) comp.color += '-' + finish

			// Apply same finish to other components
			if (key == 'TEMPLE') {
				Object.keys(config.components).filter(x => x.startsWith('TEMPLE_') && !config.components[x as ComponentType].design && isPreciousColor(config.components[x as ComponentType]?.color) && !config.components[x as ComponentType]?.color.split('/')[1].includes('-')).forEach(x =>
					config.components[x as ComponentType].color += '-' + finish
				)
			}
		} else if (isPreciousColor(comp.color) && !comp.color.split('/')[1].includes('-')) {
			comp.color += '-POL'
		}

		if (isPreciousColor(comp.color)) {
			config.requiredMaterials = config.requiredMaterials || []
			if ((key == 'NOSEPAD' || key == 'FRONT' || (!config.isRimless && (key == 'BRIDGE' || key == 'CLIP'))) && !comp.color.endsWith('-POL')) {
				config.requiredMaterials.push(replaceFinish(comp.color, 'POL'))
			}
		}
	}

	/*TEMPLE */
	if (!config.components.CLIP && config.components.TEMPLE_CLIP) config.components.CLIP = config.components.TEMPLE_CLIP

	if (config.components.TEMPLE?.design) {
		if (config.components.COVER?.color && !config.components.TEMPLE.design.includes('COVER')) {
			config.components.TEMPLE.design += '_COVER'
		} else if (config.components.TEMPLE_TIP?.color.startsWith('ACETATE/') && !config.components.TEMPLE.design.includes('TIP')) {
			config.components.TEMPLE.design += '_TIP' // 40TH aniversary RIM temples
		}

		const templeInfo = templeData[config.components.TEMPLE?.design]
		if (!templeInfo) console.warn('NO TEMPLE INFO', config.components.TEMPLE?.design)

		if (isPreciousColor(config.components.TEMPLE.color) || (templeInfo?.hingeType != 'RIM' && templeInfo?.hingeType != 'TT')) {
			delete config.components.TEMPLE.size
		}

		if (!templeInfo?.engraving) config.engraving = null

		if (templeInfo?.hingeType && templeInfo.hingeType != 'RIM') {
			if (!isPreciousColor(config.components.TEMPLE.color)) {
				const bushings = { 'TT': 'BUSHING/TT', 'BLOK': 'BUSHING/BLOK' }
				config.components.BUSHING = { design: templeInfo.hingeType, color: bushings[templeInfo.hingeType as 'TT' | 'BLOK'] ?? 'BUSHING/BLACK' }
			} else if (config.components.TEMPLE.color.startsWith('AU750/WG')) {
				config.components.BUSHING = { design: templeInfo.hingeType, color: 'AU750/YG-POL' }
			} else if (config.components.TEMPLE.color.startsWith('PT950/PT')) {
				config.components.BUSHING = { design: templeInfo.hingeType, color: 'PT950/PT-POL' }
			} else {
				config.components.BUSHING = { design: templeInfo.hingeType, color: 'AU750/WG-POL' }
			}
		}

		if (templeInfo?.hingeType == 'SPIRIT_WIRE') {
			config.components.CLIP = { design: templeInfo.hingeType, color: config.components.CLIP?.color }
			if (config.inclination == 0) config.components.CLIP.design += '-0'
			if (config.inclination == 5) config.components.CLIP.design += '-5'
			config.components.BUSHING = { design: templeInfo.hingeType, color: 'BUSHING/SPIRIT_WIRE' } // TODO: Correct color?
		} else if (templeInfo?.hingeType == 'SPIRIT_PLATE') {
			config.components.CLIP = { design: templeInfo.hingeType, color: config.components.CLIP?.color }
			config.components.BUSHING = { design: templeInfo.hingeType, color: 'BUSHING/BLACK' }
		} else if (config.isRimless) {
			console.warn('no clip')
		}

		if (templeInfo?.endType == 'SNAP-ON') {
			config.components.SNAP_ON = { color: isGoldTemple(config.components.TEMPLE.color) ? 'SNAP-ON/BROWN' : 'SNAP-ON/BLACK' }
		} else if (templeInfo?.endType == 'TEMPLE-TIP') {
			config.components.TEMPLE_TIP = { color: config.components.TEMPLE_TIP?.color || 'TEMPLE-TIP/CLEAR' }
		} else if (!config.components.COVER?.color) {
			// console.warn('No end')
		}

		if (templeInfo?.diamonds?.length) {
			templeInfo?.diamonds.forEach((color, index) => {
				// @ts-expect-error
				if (!config.components[`GEMSTONE-${index + 1}`]) config.components[`GEMSTONE-${index + 1}`] = { color }
			})
		}

		if (config.components.TEMPLE?.design?.startsWith('3') && !config.components.TEMPLE_DETAIL) {
			config.components.TEMPLE_DETAIL = { color: 'T-WIRE/P10' }
		}

		// Convert EEU9 to U9/EE AND EE05 to 05/EE
		if (config.components.TEMPLE?.color) config.components.TEMPLE.color = config.components.TEMPLE.color.replace(/(T-PLATE|T-WIRE)\/(E[A-Z])(P?U?\d+)/, '$1/$3/$2')

		// Titanium special colors, EB, EG, ED etc
		const match = /^(T-WIRE|T-PLATE)\/(.*)\/(E[A-Z])$/.exec(config.components.TEMPLE?.color)
		if (match) {
			config.components.TEMPLE.color = match.slice(1, 3).join('/')
			config.components.TEMPLE_DETAIL = { color: [config.components.TEMPLE.color, match[3]].join('-') }
			if (config.components.TEMPLE_DETAIL.color.endsWith('-EB')) {
				config.components.TEMPLE_DETAIL.color = match[1] + '/05'
			}
		}

		if (isPreciousColor(config.components.TEMPLE?.color)) templeInfo?.finishes?.map(x => config.requiredMaterials.push(replaceFinish(config.components.TEMPLE.color, x)))
		if (isPreciousColor(config.components.TEMPLE_DETAIL?.color) || isPreciousColor(config.components.TEMPLE?.color)) templeInfo?.detailFinishes?.map(x => config.requiredMaterials.push(replaceFinish(config.components.TEMPLE_DETAIL?.color || config.components.TEMPLE.color, x)))
	}

	// @ts-expect-error
	delete config.components['CLIP_ON'] // NOT USED

	if (config.isRimless) {
		// RIMLESS REMOVE BRIDGESIZE FROM LENSES
		if (config.components.MODEL?.size) config.components.MODEL.size = parseInt(config.components.MODEL?.size).toString() // 50□20, 50#20, 50□L

		// Rename Temple Clip > CLIP and remove Bridge Clip
		delete config.components.TEMPLE_CLIP
		// @ts-expect-error
		delete config.components['BRIDGE_CLIP'] // NOT USED
		delete config.components.CLIP?.size

		if (config.components.CROSSBAR) config.components.CROSSBAR = { design: 'CROSSBAR', size: bridgeSizeToMm(config.components.BRIDGE.size).toString(), color: config.components.CROSSBAR.color }

		if ((config.components.TEMPLE?.design.includes('_D') || config.components.TEMPLE?.design?.startsWith('0')) && !config.components.GEMSTONE?.color) {
			if (!config.components.TEMPLE_DETAIL?.color) config.components.TEMPLE_DETAIL = { color: config.components.TEMPLE.color.replace('AU750/BG', 'AU750/YG') }
		}
	} else {
		// NOT RIMLESS
		// Remove Front + Temple sizes until everything is modelled
		if (!config.isRimless) delete config.components.MODEL?.size
	}

	// Default Lens Color
	if (!config.components.LENSES) config.components.LENSES = { 'color': 'CLEARLENS/CLEAR' }
	if (!config.components.LENS_EDGE) {
		config.components.LENS_EDGE = {
			'color': config.components.LENSES.color == 'CLEARLENS/CLEAR' ?
				(config.isRimless ? 'CLEARLENS/EDGE-RIMLESS' : 'CLEARLENS/EDGE')
				: config.components.LENSES.color + '-EDGE'
		}
	}
	if (!config.isRimless && !config.components.GROOVE?.color) config.components.GROOVE = { 'color': config.components.LENS_EDGE.color }

	if (!config.components.NOSEPAD) config.components.NOSEPAD = { design: baseProductline == 'RIM' || baseProductline == 'AIR' ? 'SR' : 'S', color: baseProductline == 'RIM' || baseProductline == 'AIR' ? 'SILICONE/ROUND' : 'SILICONE/OVAL' }
	if (config.components.NOSEPAD?.color == 'SILICONE/CLEAR') config.components.NOSEPAD.color = baseProductline == 'RIM' || baseProductline == 'AIR' ? 'SILICONE/ROUND' : 'SILICONE/OVAL'

	if (baseProductline == 'RIM') {
		delete config.components['CLIP-ON']
		if (!config.components.CROSSBAR) config.components.CROSSBAR = {}
		if (!config.components.CROSSBAR.color) config.components.CROSSBAR.color = config.components.UPPERRIM.color
		if (!(config.components.UPPERRIM_DETAIL?.color) && config.components.UPPERRIM?.color.startsWith('T-WIRE/U3')) config.components.UPPERRIM_DETAIL = { color: 'T-WIRE/10' }

		if (config.components.GEMSTONE?.size) {
			config.components.TEMPLE.design += '_' + config.components.GEMSTONE.design + config.components.GEMSTONE.size
			config.components.TEMPLE_DETAIL = { color: config.components.TEMPLE.color.replace('AU750/BG', 'AU750/YG') }
		} else {
			delete config.components?.GEMSTONE
		}
	}

	if (baseProductline == '7000') {
		config.components.WIRE = { color: 'WIRE/CLEAR' }
	}

	if (config.components.FRONT?.color?.startsWith('HORN/') || config.components.FRONT?.color.startsWith('TRÆ/')) {
		if (!config.components.CLIP?.color) config.components.CLIP = { color: config.components.TEMPLE?.color }
		config.components.BRIDGE = { color: isPreciousColor(config.components.TEMPLE.color) ? config.components.TEMPLE.color.replace('AU750/BG', 'AU750/WG') : 'T-PLATE/P10' }
	}

	if (baseProductline == '6500') {
		config.components.NOSEPADARM = { color: 'T-WIRE/P10' }
	}

	if (baseProductline == '1000') {
		if (!config.components.CLIP?.color) config.components.CLIP = { color: config.components.TEMPLE?.color }
		config.components.BRIDGE = { color: isPreciousColor(config.components.TEMPLE?.color) ? config.components.TEMPLE.color.replace('AU750/BG', 'AU750/WG') : 'T-PLATE/P10' }
	}

	if (baseProductline == 'ATT') {
		if (!config.components.CLIP?.color) config.components.CLIP = { color: config.components.TEMPLE.color }
		config.components.NOSEPADARM = { color: 'T-PLATE/P10' }
	}

	return config
}

export function IsValidConfiguration(config: FrameConfiguration): boolean {
	if (!config.components.TEMPLE) return false
	if (config.isRimless) {
		if (!config.components.BRIDGE) return false
	} else {
		return !!config.components.FRONT || (!!config.components.UPPERRIM && (!!config.components.LOWERRIM))
	}
	return true
}

export function isPreciousColor(color: string): boolean {
	return /^AU750|PT950/.test(color)
}

export function isGoldTemple(color: string): string | undefined {
	return ['GT', 'PGT', 'YG', 'RG'].find(x => color.includes(x))
}

export function replaceFinish(colorName: string, replaceWith: string): string {
	const [group, name] = colorName.split('/')
	return group + '/' + name.split('-')[0] + '-' + replaceWith
}

export function isPrecious(configuration: FrameConfiguration): boolean {
	return !!Object.values(configuration.components).find(x => x.color?.startsWith('AU750') || x.color?.startsWith('PT950'))
}

function splitColorCodes(color: string, combinationsOnly = false): string[] {
	if (!color) return
	const colorLineCode = color.split('/')[0]
	const colorCodes = color.substring(colorLineCode.length + 1)

	if (Object.keys(combinationTypes).includes(colorLineCode)) {
		return combinationTypes[colorLineCode].map((x, i) => colorCodes.split('/')[i] ? x + '/' + colorCodes.split('/')[i] : null).filter(Boolean)
	} else if (!combinationsOnly) {
		return [color]
	}
}

function bridgeSizeToMm(size: string | number): number {
	const s = (size + '').toUpperCase()

	if (s === 'XS') return 12
	if (s === 'S') return 14
	if (s === 'M') return 16
	if (s === 'L') return 18
	if (s === 'XL') return 20

	let m = s.match(/^(\d+)XS$/)
	if (m) return 14 - 2 * +m[1]

	m = s.match(/^(\d+)XL$/)
	if (m) return 18 + 2 * +m[1]
	return +s
}
